<template>
  <b-card class="border-0 shadow-none card-secondary mb-3">
    <h5>{{ cardTitle }}</h5>

    <div class="mx-2 mt-3 mb-3 d-flex">
      <div>
        <img v-if="iconLink" :src="iconLink" width="24" height="24" class="pin-icon" />
        <b-icon-geo-alt-fill v-else :font-scale="1.2" variant="primary" class="pin-icon" />
      </div>
      <div class="d-flex flex-column pl-2">
        <span class="caption text-bold">{{ title }}</span>
        <span>{{ subTitle }}</span>
      </div>
    </div>

    <div class="d-flex justify-content-end">
      <b-button variant="secondary" @click="$emit('ctaClick')" size="sm" class="px-3">
        {{ buttonTitle }}
      </b-button>
    </div>
  </b-card>
</template>

<script>
export default {
  name: "ProgressState",
  props: {
    cardTitle: String,
    buttonTitle: String,
    title: String,
    subTitle: String,
    iconLink: String,
  },
};
</script>
